/**
 * Add a new company
 *
 * @param company
 * @returns {function(*)}
 */
import {addNotification as notify} from 'reapop';
import * as costActions from "../graphql/actions/cost";
import l10n from "../l10n/localization";
import * as types from "../constants/actionTypes";
import * as creationActions from "./creation";
import * as ajaxRoutes from "../constants/ajaxRoutes";
import * as authHandler from "../utils/authHandler";

export function add(cost) {
    return dispatch => {
        dispatch(loading());
        dispatch(saving(cost));
        costActions.add(
            function (response) {
                dispatch(saved(response.data.createCost));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                dispatch(creationActions.receivednewlyCreatedCost(response.data.createCost));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            cost
        );
    };
}


export function edit(cost, fogID) {
    let id = cost.id;
    delete cost.id;
    delete cost.__typename;
    delete cost.url;
    delete cost.invoiceFile;

    return dispatch => {
        dispatch(loading());
        dispatch(saving(cost));
        costActions.edit(
            function (response) {
                dispatch(saved(response.data.editCost));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                dispatch(fetchCosts(fogID, true));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            id,
            cost
        );
    };
}

export function uploadFile(id, file) {
    return dispatch => {
        var url = ajaxRoutes.API_ROUTE + "/cost/upload/"+id;
        var form = new FormData();
        form.append('file', file);
        var headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});

        fetch(url, {method: 'POST', body: form, headers: headers})
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }
                return response.json().then(json => {
                    const error = new Error(json.message || response.statusText)
                    return Promise.reject(Object.assign(error, { response }))
                });
            })
            .then((data) => {
                dispatch(notify({message: data.message, status: 'success'}));
                dispatch(updateFileUrl(id, data.fileUrl));
            })
            .catch((error) => {
                dispatch(notify({message: error.message, status: 'error'}));
            });
    };
}

export function fetchCosts(fogId, force = false) {
    return dispatch => {
        dispatch(loading());
        costActions.getCosts(
            function (response) {
                dispatch(receiveCosts(response.data.costs));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
            },
            fogId,
            force
        );
    };
}


export function get(id, force = false) {
    return dispatch => {
        dispatch(loading());
        costActions.get(
            function (response) {
                dispatch(receiveCost(response.data.cost));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
            },
            id,
            force
        );
    };
}




export function loading() {
    return {
        type: types.LOADING_COST
    };
}

export function saving(cost) {
    return {
        type: types.SAVING_COST,
        payload: cost
    };
}

export function updateFileUrl(id, url) {
    return {
        type: types.UPDATED_FILE,
        payload: {
            id,
            url
        }
    };
}

export function saved(cost) {
    return {
        type: types.SAVED_COST,
        payload: cost
    };
}

export function errorSaving() {
    return {
        type: types.ERROR_SAVING_COST,
    };
}

export function receiveCosts(data) {
    return {
        type: types.RECEIVED_COSTS,
        payload: data
    };
}


export function receiveCost(data) {
    return {
        type: types.RECEIVED_COST,
        payload: data
    };
}

export function updateFormDataCost(formData = {}) {
    return {
        type: types.UPDATEFORMDATA_COST,
        payload: {
            formData: formData
        }
    }
}

export function clearFormDataCost() {
    return {
        type: types.CLEARFORMDATA_COST
    }
}

export function errorMessage(message) {
    return dispatch => {
        dispatch(notify({message: message, status: 'error',dismissAfter: 8000}));
    };
}


// WEBPACK FOOTER //
// ./src/actions/cost.js